import { toJSon } from '@/utils/tool'
export const typeMap = {
  tourist: 1,
  shopping: 2,
  freeActivity: 3,
  ownpayActivity: 4,
  traffic: 5,
}
export const typeNameMap = {
  [typeMap.tourist]: '景点',
  [typeMap.shopping]: '购物店',
  [typeMap.freeActivity]: '自由活动',
  [typeMap.ownpayActivity]: '自费项目',
  [typeMap.traffic]: '交通',
}

export const journeyItemMap = [
  'touristCount',
  'freeActivityCount',
  'mealCount',
  'ownpayActivityCount',
  'shoppingCount',
]
export const journeyItem = {
  touristCount: '景点',
  freeActivityCount: '自由活动',
  mealCount: '餐饮',
  ownpayActivityCount: '自费项目',
  shoppingCount: '购物店',
}

export const navbars = [
  {
    title: '特色',
    dom: 'recommend',
  },
  {
    title: '行程',
    dom: 'journey',
  },
  {
    title: '费用',
    dom: 'fee',
  },
  {
    title: '须知',
    dom: 'instructions',
  },
  {
    title: '点评',
    dom: 'comment',
  },
]
// 为酒店套餐时没有行程信息
export const navbar = [
  {
    title: '特色',
    dom: 'recommend',
  },
  {
    title: '费用',
    dom: 'fee',
  },
]
export const buttonText = {
  0: '产品已停用',
  1: '立即预订',
  2: '产品已下架',
}
export const buttonGoodsText = {
  0: '产品已停用',
  1: '立即购买',
  2: '产品已下架',
}
export const rsaOption = { alg: 'SHA256withRSA' }

export const begin = 'begin'
export const end = 'end'
export const split = '-'
export const privateKey = 'private'
export const publicKey = 'public'

export const publicArray = [
  'TUlJQklqQU5CZ2tx',
  'GtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF4NnVkeU1PbDB4TUszWEZydlQ5TAoxTm83bEI3SStFRHMreDlsNFpYWXBvSTlJR3ZucWxHVW54WVpVTkxTUmtLN2VM',
  'FFyTjAvdXUwM0pxVE0vSkxmCkJDeFhTMXovelgvYUFhTGxJNVZvWTdsQ2N0',
  'zk1RDF',
  'MC9HYk9NTWpnekRJYklyYWZEUks1Z1JYVElqU2NlbTkKNDhnci91SUhFNmJPOXgvZzZtK0tsWm1vdis1SnZJeVkzbGl',
  'K05sT09mYndiQzFYUWhzVGhJcDNYdGNr',
  'TNZegoyMUpEUnd0Z2VHeFA5L1dPMDlYRUdxN0Zx',
  'HU4',
  '1FyUk1Y',
  '1g5bzd1bHhRYTVmeDI3Z0xwRHRSbmxmR2Vz',
  'nVwCjdMN1RjZHcxODVHZStDT3JLTmFPdW5xeUJDRzhlY3JXWG9DT0ZOQWdLcC9NU1kyOWJSZUxVYUl4bXpWRnNTWGUKdFFJREFRQUI=',
]
// 以下渠道码，终端码参照http://59.110.124.240:42189/pages/viewpage.action?pageId=25986711&wework_cfm_code=OdsBBtV4iNgPYq6WGc1u3TVBoMDdgeZLc5ZMhF9KexcmQzkEZSN%2B%2FPsUBLVExwUC7bm2yQMnxSmz%2BpY40vwdkiAnEsag25B6CrrZEU99dtKbENl%2Fi6xU2togPblm7SgTfw%3D%3D
// 容器类型
export const TERMINAL_MAP = {
  cloudQuickPayMini: '0', // 云闪付小程序
  wechatMini: '1', // 微信小程序
  normalBrowser: '2', // 普通浏览器
  app: '3', // 中旅APP
  tiktok: '4', // 抖音小程序
  bestPay: '5', // 翼支付App
  ctsPay: '6', // 中旅通
}
// 应用类型
export const APP_MAP = {
  pgy: '1', // 我和旅行蒲公英云店
  zllx: '2', // 中旅旅行
  zggl: '3', // 中国国旅
  zlyd: '4', // 中旅云店
  nbs: '5', // nbs后台
}
// 终端码
export const TERMINAL_CODE_MAP = {
  [TERMINAL_MAP.normalBrowser]: {
    [APP_MAP.zllx]: '04', // mock 03
  },
  [TERMINAL_MAP.wechatMini]: {
    [APP_MAP.zllx]: '04',
    [APP_MAP.zlyd]: '06',
    [APP_MAP.pgy]: '07',
  },
  [TERMINAL_MAP.ctsPay]: {
    [APP_MAP.zllx]: '12',
  },
  [TERMINAL_MAP.cloudQuickPayMini]: '08',
  [TERMINAL_MAP.tiktok]: {
    [APP_MAP.zllx]: '09',
  },
  [TERMINAL_MAP.bestPay]: {
    [APP_MAP.zllx]: '10',
  },
  [TERMINAL_MAP.app]: {
    [APP_MAP.zllx]: '02', // app
  },
}
export const SOURCE_DEFAULT_CODE = '14|75|76' // 默认渠道码，对应文档里的静默用户，中旅旅行微信小程序
// 渠道码
export const SOURCE_FLAG_MAP = {
  [TERMINAL_MAP.cloudQuickPayMini]: {
    [APP_MAP.zllx]: '26|29|31',
  },
  [TERMINAL_MAP.bestPay]: {
    [APP_MAP.zllx]: '26|27|103',
  },
  [TERMINAL_MAP.wechatMini]: {
    [APP_MAP.zllx]: SOURCE_DEFAULT_CODE,
  },
  [TERMINAL_MAP.tiktok]: {
    [APP_MAP.zllx]: '14|79|102',
  },
}
// 推广码
export const CREATOR_PROMOTION_MAP = {
  [TERMINAL_MAP.cloudQuickPayMini]: '9ngu',
  [TERMINAL_MAP.bestPay]: 'ug9p',
  [TERMINAL_MAP.wechatMini]: '',
  [TERMINAL_MAP.tiktok]: 'lp4z',
  [TERMINAL_MAP.normalBrowser]: '',
}
// 跳转梁硕携带的url终端标识
export const URL_TERMIAL_FLG_MAP = {
  [TERMINAL_MAP.cloudQuickPayMini]: {
    [APP_MAP.pgy]: '',
    [APP_MAP.zllx]: '',
    [APP_MAP.zggl]: '',
  },
  [TERMINAL_MAP.wechatMini]: {
    [APP_MAP.pgy]: 'isVdian',
    [APP_MAP.zllx]: 'isZllx',
    [APP_MAP.zggl]: 'isZggl',
  },
  [TERMINAL_MAP.normalBrowser]: {
    [APP_MAP.pgy]: '',
    [APP_MAP.zllx]: '',
    [APP_MAP.zggl]: '',
  },
}
// 订单状态code
export const ORDER_STATUS_CODE = {
  operating: 'OS0000',
  disposeing: 'OS0001',
  awaitPayAndSign: 'OS0026',
  awaitPay: 'OS0011',
  awaitSign: 'OS0010',
  goMsgSending: 'OS0020',
  changing: 'OS0030',
  awaitGo: 'OS0040',
  traveling: 'OS0050',
  goBack: 'OS0060',
  hasCancel: 'OS0099',
  awaitRefund: 'NT0100',
}
export const ORDER_STATUS_TXT = {
  [ORDER_STATUS_CODE.operating]: '正在处理',
  [ORDER_STATUS_CODE.awaitPayAndSign]: '待付款签约',
  [ORDER_STATUS_CODE.awaitPay]: '待付款',
  [ORDER_STATUS_CODE.awaitSign]: '待签约',
  [ORDER_STATUS_CODE.goMsgSending]: '出游通知发送中',
  [ORDER_STATUS_CODE.changing]: '变更处理中',
  [ORDER_STATUS_CODE.awaitGo]: '待出游',
  [ORDER_STATUS_CODE.traveling]: '出游中',
  [ORDER_STATUS_CODE.goBack]: '出游归来',
  [ORDER_STATUS_CODE.hasCancel]: '已取消',
  [ORDER_STATUS_CODE.awaitRefund]: '退款中',
}
// 游客类型
export const TOUR_TYPE_MAP = {
  ADULT: 0, // '成人'
  KID: 1, //'儿童',
}
// 券状态
export const TOUSE = 0
export const OVERDUE = 1
export const HAVEUSED = 2
export const HAVETORECEIVE = 3
export const HASGONE = 4
export const ECEIVE = 5
export const CouponStatus = [
  { label: '去使用', value: TOUSE },
  { label: '已过期', value: OVERDUE },
  { label: '已使用', value: HAVEUSED },
  { label: '已领取', value: HAVETORECEIVE },
  { label: '已抢光', value: HASGONE },
  { label: '领取', value: ECEIVE },
]
export const CouponStatusJson = toJSon(CouponStatus)
// 调活动列表接口入参 0已使用 ,1未使用, 2已过期 ,3已作废 ,98已使用/已过期 ,99全部
export const UNUSED = 1 //1,未使用
export const HAVEUSED_OVERDUE = 98 //已使用/已过期
export const ALLSTATE = 99 //全部

export const active_code = {
  MKT4034000: '活动太火爆~名额已经被抢光了，下次要快哦~',
  MKT4035000: '您当前还不满足活动参加条件哦~',
  MKT4035100: '活动太火爆~名额已经被抢光了，下次要快哦~',
  MKT4036000: '您当前还不满足活动参加条件哦~ ',
  MKT4037500: '此活动与优惠券活动不能共享',
  MKT4037200: '您当前还不满足活动参加条件哦~',
  MKT4037100: '活动太火爆~名额已经被抢光了，下次要快哦~',
  MKT4037000: '您当前还不满足活动参加条件哦~  ',
}
// 年龄 0成人 1儿童 2婴儿
export const AGE_MAP = {
  baby: 2,
  child: 1,
  adult: 0,
}
// 计价方式
export const PricingMethodEnum = {
  PERCAPITA: 1, // 按人计价
  COVER: 2, // 2按套计价
}
// 计价单位
export const ChargeUnitEnum = {
  PERCAPITAUNIT: 1, // 按人计价
  COVERUNIT: 2, // 2按套计价
  SHEETUNIT: 3, //按张计价
}
export const packageTicketEnum = {
  noInclude: 0, // 不包含门票
  include: 1, // 包含门票
}
// 成人标准
export const adultCostStandardTO = {
  0: '12周岁以上',
  1: '##周岁以上',
  2: '身高##米以上',
  3: '',
}
// 儿童标准
export const childCostStandardTO = {
  0: '2-12周岁（包含）',
  1: '##-&&周岁（包含）',
  2: '身高##-&&米（包含）',
}
// 资源类型为4 时
export const Hotel_Package = 4
export const TEL_NUMBER = '400-600-8888'
export const PRODUCT_TYPE = 'DJ' // 跳转梁硕写死的路由参数，基本没啥用，JJ不支持分次支付

// 采购规则
export function PurchaseTypeEnum() {
  const one = 1 // 库存+现询
  const two = 2 // 库存
  const three = 3 // 自由售卖
  const four = 4 // 现询

  return {
    one,
    two,
    three,
    four,
  }
}
export const DistributionEnum = {
  DirectSelling: 1, // 直销
  Distribution: 2, // 分销
}
// 中旅旅行微信小程序appId
export const zllxMiniAppId = 'wx56a6e0e5d7b06a52'

// 酒店排序
export const sortType = [
  {
    id: 0,
    name: '综合排序',
  },
  {
    id: 1,
    name: '价格 低-高',
  },
  {
    id: 2,
    name: '价格 高-低',
  },
]

/******* 签证/认证CodeMap Start *******/
// 证类型
export const CERT_TYPE = {
  visa: 0, // 签证
  cert: 1, // 认证
}

// 签证-入境次数codeMap
export const ENTRY_TIMES = {
  single: 1, // 单次
  multiple: 2, // 多次
  other: 3, // 其他
}
// 签证-有效期codeMap
export const PERIOD_OF_VALIDITY = {
  day: 1, // 按天
  year: 2, // 按年
  other: 3, // 其他
}
// 签证-最长停留codeMap
export const DURATION_OF_STAY = {
  day: 1, // 按天
  year: 2, // 按年
  other: 3, // 其他
}

// 签证-是否面试codeMap
export const INTERVIEW_TYPE = {
  no: 1, // 无需面试
  extract: 2, // 抽取面试
  submit: 3, // 本人递交
  fingerprint: 4, // 采集指纹
}
// 签证-是否面试枚举
export const InterviewTypeArr = [
  { code: INTERVIEW_TYPE.no, name: '无需面试' },
  { code: INTERVIEW_TYPE.extract, name: '抽取面试' },
  { code: INTERVIEW_TYPE.submit, name: '本人递交' },
  { code: INTERVIEW_TYPE.fingerprint, name: '采集指纹' },
]

// 签证材料适用人群-人员类型codeMap
export const PERSONNEL_TYPE = {
  employeesOnJob: 1, // 在职人员
  freelancers: 2, // 自由职业
  schoolStudents: 3, // 在校学生
  retirees: 4, // 退休人员
  preschoolChildren: 5, // 学龄前儿童
  foreigners: 6, // 外籍人员
}
// 签证材料适用人群-人员类型枚举
export const PersonnelTypeArr = [
  { code: PERSONNEL_TYPE.employeesOnJob, name: '在职人员' },
  { code: PERSONNEL_TYPE.freelancers, name: '自由职业' },
  { code: PERSONNEL_TYPE.schoolStudents, name: '在校学生' },
  { code: PERSONNEL_TYPE.retirees, name: '退休人员' },
  { code: PERSONNEL_TYPE.preschoolChildren, name: '学龄前儿童' },
  { code: PERSONNEL_TYPE.foreigners, name: '外籍人员' },
]

// 材料是否必备
export const MATERIALS_NECESSARY = {
  true: 1, // 是
  false: 0, // 否
}

// 材料附件类型
export const ATTACHMENT_TYPE = {
  sample: 0, // 样本
  template: 1, // 空白模板
}

// 是否需要发票
export const NEED_INVOICE = {
  true: true, // 需要发票
  false: false, // 不需要发票
}
export const needInvoiceArr = [
  { code: NEED_INVOICE.false, label: '不需要' },
  { code: NEED_INVOICE.true, label: '需要' },
]

// 发票性质
export const INVOICE_NATURE = {
  electronic: 1, // 电子发票
  paper: 2, // 纸质发票
}
export const invoiceNatureArr = [
  { code: INVOICE_NATURE.electronic, label: '电子发票' },
  { code: INVOICE_NATURE.paper, label: '纸质发票' },
]

// 抬头类型
export const TITLE_TYPE = {
  personal: 1, // 个人
  enterprise: 2, // 企业
}
export const titleTypeArr = [
  { code: TITLE_TYPE.personal, label: '个人' },
  { code: TITLE_TYPE.enterprise, label: '企业' },
]

/******* 签证/认证CodeMap End *******/
// 优惠活动类型  0 立减 1 满减 2 满减卷
export const ACTIVE_TYPE_CODE = {
  immeReduce: 0,
  fullReduce: 1,
  coupon: 2,
}
// 频道对应的id
export const CHANNEL_ID = {
  hotel: 6, // 酒店
  visa: 8, // 签证
  cert: 60, // 认证
}
export const BEST_PAY_ENV = {
  BEST_PAY_CLIENT_ID: '86000000339',
  BEST_PAY_MERCHANT_CODE: '3178036926629994',
  BEST_PAY_STATE: 'Ctg85118522',
}
